import { hex2ustring } from "../hex";
function isNil(value) {
    return value === null || value === undefined;
}
const AND = hex2ustring('0026');
export function sortParams(payload) {
    const params = typeof payload === 'string' ? JSON.parse(payload) : payload;
    const paramsKeys = Object.keys(params).map(x => x + '').sort();
    return paramsKeys.reduce((acc, key) => {
        const value = isNil(params[key]) ? '' : params[key].toString();
        acc.push(`${key}=${value}`);
        return acc;
    }, []).join(AND);
}
